<app-modal [isOpen]="isOpen()" (closeModal)="isOpenChange.emit()" size="lg">
  <ng-container header>Supplier Selection</ng-container>

  <form body #supplierForm [attr.novalidate]="null">
    <div class="text-left space-y-3">
      @for (group of groups(); track group.vendorName) {
        @let expanded = isGroupExpanded(group.vendorName);
        @let isExternal = group.sources[0].type === 'external';

        <div>
          <app-card>
            <div class="card-grid" [class.h-24]="!(group.sources.length >= 4 && isGroupExpandedOrAnimating(group.vendorName))" [class.min-h-24]="group.sources.length >= 4 && isGroupExpandedOrAnimating(group.vendorName)">
              <div class="[grid-area:label] whitespace-nowrap overflow-hidden text-ellipsis">
                <app-checkbox [checked]="group.checked" (valueChange)="onCheckboxChange(group, $event)" [label]="group.label"/>
              </div>

              <div class="[grid-area:cost] text-sm text-gray-700 dark:text-gray-300 text-right whitespace-nowrap">
                @if (!isExternal) {
                  <span class="font-bold text-body">Cost:</span> {{ group.cost | currency }}
                }
              </div>

              <div class="[grid-area:price] text-sm text-gray-700 dark:text-gray-300 text-right whitespace-nowrap">
                @if (priceFor(group.cost); as price) {
                  <span class="font-bold text-body">Price:</span> {{ price | currency }}
                }
              </div>

              @if (isExternal) {
                <div class="[grid-area:.] w-24">
                  @if (group.selected_quantity > 0) {
                    <app-number [required]="true" inputmode="decimal" (valueChange)="onCostChange(group, $event)" [value]="group.sources[0].cost" [min]="1" [max]="9999" [step]="0.01" label="Cost"/>
                  }
                </div>
              } @else if (group.sources.length > 1) {
                <div class="[grid-area:avail] text-sm text-gray-500 dark:text-gray-400 text-right">
                  @for (source of group.sources; track source.name; let i = $index) {
                    <div class="whitespace-nowrap transition-all duration-500 ease-in-out"
                         [class.max-h-0]="isSourceHidden(group, i)"
                         [class.opacity-0]="isSourceHidden(group, i)"
                         [class.overflow-hidden]="isSourceHidden(group, i)"
                         [class.max-h-10]="!isSourceHidden(group, i)"
                         [class.opacity-100]="!isSourceHidden(group, i)"
                         [class.mb-0.5]="!isSourceHidden(group, i)">
                      {{ source.name }}: <span class="font-bold text-body">{{ getAvailable(source) }}</span>
                    </div>
                  }
                  @if (group.sources.length >= 4) {
                    <app-link class="text-sm relative overflow-hidden ms-2" (click)="toggleGroup(group.vendorName)">
                      <span class="inline-block transition-opacity duration-300 ease-in-out absolute whitespace-nowrap" [class.opacity-0]="expanded" [class.opacity-100]="!expanded">
                        Show More <app-icons icon="arrow-right"></app-icons>
                      </span>
                      <span class="inline-block transition-opacity duration-300 ease-in-out" [class.opacity-0]="!expanded" [class.opacity-100]="expanded">
                          Show Less <app-icons icon="arrow-up"></app-icons>
                      </span>
                    </app-link>
                  }
                </div>
              } @else {
                <div class="[grid-area:avail] text-sm text-gray-500 dark:text-gray-400 text-right whitespace-nowrap">
                  Available:
                  <span class="font-bold text-body">{{ getAvailable(group.sources[0]) }}</span>
                </div>
              }

              <app-number class="[grid-area:qty] w-24" [required]="group.checked" [min]="0" [max]="group.total_available"
                          [value]="group.selected_quantity || ''" (valueChange)="onQuantityChange(group, $event)" label="Qty"/>
            </div>
          </app-card>
        </div>
      }
    </div>
  </form>

  <div footer>
    <div class="text-body text-xs flex justify-between h-8">
      @for (otd of otdForItem(); track $index) {
        <div class="fade-slide-in">{{ otd.quantity }} | <span class="font-semibold">{{ otd.total | currency }}</span></div>
      }
    </div>

    <div class="flex justify-end gap-2">
      @if (resultTableService.modalMode() === 'quote') {
        @if (access.has('quick_add')) {
          <app-button id="supplier-selection-quick-add" size="small" variant="secondary"
                      [disabled]="resultsStore.isPricingPending() || access.cannot('quick_add')"
                      [title]="access.getTitle('quick_add', 'Add to RO without PO')"
                      (click)="supplierForm.reportValidity() && onQuickAdd()">
            + Quick Add
          </app-button>
        }

        <app-button id="supplier-selection-add-to-quote" size="small" [disabled]="resultsStore.isPricingPending()" title="Add to Quote"
                    (click)="supplierForm.reportValidity() && onAddToQuote()">
          <div class="flex items-center gap-1">
            <app-icons icon="add-column-before" svgClass=""></app-icons>
            Add to Quote
          </div>
        </app-button>
      } @else {
        <app-button size="small" [disabled]="resultsStore.isPricingPending()" (click)="supplierForm.reportValidity() && onSelect()">
          Select
          <app-icons icon="arrow-right"/>
        </app-button>
      }
    </div>
  </div>
</app-modal>
